<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <h2 class="titulo-pagina">{{'ALIADOSUSUARIOS.LBL_EDITARUSUARIO'|translate}}</h2>
    </div>
  </div>
  <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="idFormAliado" name="nomAliado">
    <div class="grid form-group">
      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>* {{ 'ALIADOSUSUARIOS.LBL_USUARIO' | translate }}</label>
          <div *ngIf="!aliado">
            <p-autoComplete placeholder="{{ 'LBL_BUSCAR' | translate}}" optionLabel="usuarioSistema" name="buscar" id="buscar"
                            formControlName="usuario"
                            autocomplete="off"
                            [suggestions]="resUsuarios"
                            [forceSelection]="true"
                            (completeMethod)="buscar($event)"
                            (onClear)="limpiar()"
                            (onSelect)="capturarUsuario($event)"
                            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            showEmptyMessage="true">
            </p-autoComplete>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idUsuario.invalid">
              {{ 'ALIADOSUSUARIOS.LBL_USUARIO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
          <label class="falso-combo-texto" *ngIf="aliado">{{f.usuario.value?.usuarioSistema}}</label>
          <div class="p-message p-messages-error p-corner-all" *ngIf="usuExiste">
            {{ 'ALIADOSUSUARIOS.MSG_USUARIOEXISTE' | translate}}
          </div>

        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>* {{ 'ALIADOSUSUARIOS.LBL_CORREOELECTRONICO' | translate }}</label>
          <input type="text" pInputText id="idCorreoElectronico"
                 name="nomCorreoElectronico"
                 autocomplete="off"
                 formControlName="correoElectronico"
                 [maxlength]="100"
                 [appEmailSuggest]="true" [dominios]="dominios.dominios"

          >
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.correoElectronico.invalid">
            {{ 'ALIADOSUSUARIOS.LBL_CORREOELECTRONICO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>* {{ 'ALIADOSUSUARIOS.LBL_TELEFONO' | translate }}</label>
          <p-inputMask mask="(999) 999-9999" formControlName="telefono" autocomplete="off"
                       placeholder="(999) 999-9999"></p-inputMask>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.telefono.invalid">
            {{ 'ALIADOSUSUARIOS.LBL_TELEFONO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
    </div>
    <div class="grid form-group">
      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>{{ 'ALIADOSUSUARIOS.LBL_IMEI' | translate }}</label>
          <label class="falso-combo-texto">{{ aliado ? aliado.imei : ''}}</label>
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-4 pt-5">
        <p-checkbox label="{{ 'ALIADOSUSUARIOS.LBL_CHECKIN' | translate}}" binary="true"
                    id="idCheckIn"
                    name="nomCheckIn"
                    formControlName="indicadorCheckIn"></p-checkbox>
      </div>
      <div class="col-12 md:col-4 lg:col-4 pt-5">
        <div class="div-form">
          <label style="margin-right: 10px">{{ 'ALIADOSUSUARIOS.LBL_VALIDACIONUBICACION' | translate }}</label>
          <p-inputSwitch formControlName="indicadorValidarUbicacion"></p-inputSwitch>
        </div>
      </div>
    </div>
    <div class="grid form-group">
      <div class="col-12 md:col-4 lg:col-4">
        <p-checkbox label="{{ 'LBL_HABILITADO' | translate}}" binary="true"
                    id="idHabilitado"
                    name="nomHabilitado"
                    formControlName="indicadorHabilitado"></p-checkbox>
      </div>
    </div>

    <div class="grid form-footer-buttons">
      <div class="form-group col-12">
        <div *ngIf="!guardando">
          <a (click)="regresar(formulario.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
          <button icon="fa fa-floppy-o" label="{{'BTN_GUARDAR' | translate }}"
                  type="submit"
                  pButton></button>
        </div>
        <div *ngIf="guardando">
          <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
          <span>{{'LBL_GUARDANDO' | translate }}</span>
        </div>
      </div>
    </div>
  </form>

</div>

<p-confirmDialog #cd key="aliado-editar">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>


